import React, { useState } from 'react';
import { useAlpacaBackend } from '@/hooks/useAlpacaBackend';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const AlpacaBackendExample: React.FC = () => {
  const {
    loading,
    error,
    getAccount,
    setAlpacaCredentials,
    buyStock,
    sellStock,
    getOrders,
    getPositions
  } = useAlpacaBackend();

  const [symbol, setSymbol] = useState('AAPL');

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Alpaca Backend Example</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="flex gap-2 items-center">
            <input value={symbol} onChange={e => setSymbol(e.target.value.toUpperCase())} className="border px-2 py-1 rounded" />
            <Button disabled={loading} onClick={() => getAccount()}>Get Account</Button>
            <Button disabled={loading} onClick={() => buyStock({ symbol, qty: 1, type: 'market', time_in_force: 'day' })}>Buy</Button>
            <Button disabled={loading} onClick={() => sellStock({ symbol, qty: 1, type: 'market', time_in_force: 'day' })} variant="destructive">Sell</Button>
            <Button disabled={loading} onClick={() => getOrders()}>Orders</Button>
            <Button disabled={loading} onClick={() => getPositions()}>Positions</Button>
          </div>
          {error && <div className="text-red-600 text-sm">Error: {error}</div>}
        </CardContent>
      </Card>
    </div>
  );
};

export default AlpacaBackendExample;
